export default __webpack_public_path__ + "static/media/plus.68f643f5.svg";